module.exports = __webpack_public_path__ + "static/media/music-logo.6fc9ba7b.png";